import React, { Component } from "react";
import { Card, Container, Row, Col, Collapse, Table } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import HttpClient from "../../../providers/http/GlasschainMsaHttpClient.js";

const columns = [
  { dataField: "receiptLocation", text: "" },
  { dataField: "AWAITING-QA", text: "Await QA" },
  { dataField: "AWAIT-DISPOSITION", text: "Await Disp" },
  { dataField: "TO-AUTOPILOT", text: "To Autopilot" },
  { dataField: "POSTED-TO-FAMOUS", text: "Famous Posted" },
  { dataField: "AWAITING-FAMOUS", text: "Await Famous"},
  { dataField: "TAGREPRINT-REQUESTED", text: "Reprint Request"},
  { dataField: "FAMOUS-TAGS-PRINTED", text: "Tags Printed"},
  { dataField: "COMPLETE", text: "Complete"},
  { dataField: "VOIDED", text: "Voided"},
  { dataField: "AWAITING-FAMOUS-RETRY", text: "Retry Famous"},
  { dataField: "TAGPRINT-ERROR", text: "Print Error"}
];

const locationStatusCountHoursAgo = 24;
const refreshDelay = 15000;

export default class ToDateTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tableData: [{receiptLocation: "Totals"}],
      totalsOnly: false,
      moreCaret: "caret-down",
      isLoading: true
    };
    this.httpClient = new HttpClient();
    this.syncTimer = null;

    this.refreshData = this.refreshData.bind(this);
    this.renderHeaderColumns = this.renderHeaderColumns.bind(this);
    this.renderRow = this.renderRow.bind(this);
    this.renderRows = this.renderRows.bind(this);
    this.toggleTotalsOnly = this.toggleTotalsOnly.bind(this);
    this.fetchTotalsOnly = this.fetchTotalsOnly.bind(this);
  }

  async componentDidMount(){
    await this.refreshData();
    this.syncTimer = setInterval(() => this.tick(), refreshDelay);
    console.log("Set Current Status syncTimer: " + this.syncTimer);
  }

  /*
  componentDidUpdate(prevProps, prevState) {
    if (prevState.delay !== this.state.delay) {
      clearInterval(this.interval);
      this.syncTimer = setInterval(() => this.tick(), refreshDelay);
    }
  }
  */


  componentWillUnmount()
  {
    if ((this.syncTimer) && (this.syncTimer !==""))
    {
      console.log("clearing Current Status interval on componentWillUnmount...");
      clearInterval(this.syncTimer);
    }
  }

  async tick()
  {
    console.log("Current Status Tick...");
    if ((this.syncTimer) && (this.syncTimer !==""))
    {
      console.log("clearing Current Status interval on tick...");
      clearInterval(this.syncTimer);
    }
    await this.refreshData();
    this.syncTimer = setInterval(() => this.tick(), refreshDelay);
  }


  async refreshData()
  {
    this.setState({isLoading: true});
    var newTableDataResult =  await this.httpClient.fetchLocationStatusCounts(locationStatusCountHoursAgo);
    var newTableData = newTableDataResult.data.data;
    console.log("table data:");
    console.info(newTableData);
    this.setState({
      tableData: newTableData,
      isLoading: false
    });

  }

  toggleTotalsOnly(){
    let newTotalsOnly = (!this.state.totalsOnly);
    let newCaretState = (newTotalsOnly) ? "caret-down" : "caret-up";
    this.setState({
      totalsOnly: newTotalsOnly,
      moreCaret: newCaretState
    });
  }





  fetchTotalsOnly(){
    /*
    let totalsRw = this.state.tableData.find((rw) => {
      return rw.source === "Totals";
    });
    */
    let result = [];
    //let totalsRw = {};
    /*
    for (var i=0; i<columns.length; i++)
    {
      totalsRw[columns[i].text] = "";
    }
    */
    //result.push(totalsRw);
    return result;
  }

  renderHeaderColumns(){
    let result = columns.map((col) =>{
      return <th style={{padding: "2px"}}>{col.text}</th>
    });
    return result;
  }


  renderRows(){
    var rowsToRender = (this.state.totalsOnly) ? this.fetchTotalsOnly() : this.state.tableData;
    let result = rowsToRender.map(rw => {
      return (
      <tr>
          {this.renderRow(rw)}
      </tr>
      )
    })
    return result;
  }

  renderRow(rw){
    let result = columns.map((col) =>{
      return <td style={{padding: "2px"}}>{rw[col.dataField]}</td>
    });
    return result;
  }

  render() {

    const loadingIcon = (this.state.isLoading) ? 
      <FontAwesomeIcon icon="sync-alt" color="green" spin/> :
      ""

    return (
      <Card border="light" bg="light" fluid="true">
        <Card.Header align="right" onClick={this.toggleTotalsOnly}>
          <span style={{float: "left"}}>
          <FontAwesomeIcon icon={this.state.moreCaret}/>&nbsp;&nbsp;Current Status (last {locationStatusCountHoursAgo} hours)
          </span>
          <span style={{float: "right"}}>{loadingIcon}</span>
        </Card.Header>
        <Card.Body>
          <Table striped bordered hover responsive="sm" style={{fontSize: 9}}>
            <thead>
              <tr>
                {this.renderHeaderColumns()}
              </tr>
            </thead>
            <tbody>
              {this.renderRows()}
            </tbody>

          </Table>
        </Card.Body>
      </Card>
    );
  }
}
